module.exports = __webpack_public_path__ + "static/media/Floor 1_worker_sel.b3fea1ec.svg";